import React from "react";

const moin_shaikh = () => {
  return (
    <div>
      <h1>Moin Shaikh</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The shortlisting was based on CGPA, with a minimum CGPA of 7 as the
        eligibility criterion.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        Aptitude Test -&gt;Technical Interview -&gt;HR Interview
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
      </p>

      <p>
        Conceptual questions from Cloud Architecture, SDLC, and Computer
        Networks.
        <br />
        Two coding problems - one easy and one medium-level
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        15 were selected for the technical interview
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
      </p>

      <p>
        The interviews were scheduled the very next day. With little time, I
        quickly revisited my projects and revised core subjects like CN, DBMS,
        and OOPs.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <p>There were two main interview rounds - one technical and one HR.</p>

      <p>
        In the Technical Round, I was asked questions on DSA, DBMS, and Computer
        Networks. I was asked to solve problems such as reversing a linked list,
        and to explain topics like ACID properties, normalization with examples,
        subnetting and the OSI model. Out of 15 students, 8 were shortlisted for
        the HR round.
      </p>

      <p>
        The HR Round was more like a conversation. The interviewer asked
        questions like “Why BP?” and “What would you do if you received a better
        offer?” .After this round, 5 students were finally selected for the
        internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviewer focused on DSA, along with core subjects such as DBMS
        and Computer Networks.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        For coding and DSA, I practiced from LeetCode’s 150 Interview Questions.
        For Computer Networks, “Computer Networking: A Top-Down Approach” is a
        good book. For DBMS and OOPs, Apna College videos. IndiaBix for time
        management and aptitude questions practice.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
      </p>

      <p>
        Understand common DSA patterns and break problems into smaller
        parts.Consistently practice on platforms like LeetCode or HackerRank.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        The interviewer asked about the implementation details of my projects,
        the technologies used, and challenges faced.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Try to research BP, be yourself in the HR round, and make sure you’re
        well-prepared to talk about your projects.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        This journey can be a bit tough sometimes, but just stay calm and keep
        doing your best.
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:moinhasan1974@gmail.com">moinhasan1974@gmail.com</a>
        <br />
        <strong>LinkedIn:</strong>{" "}
        <a href="https://in.linkedin.com/in/moin-hasan-shaikh-2329a227a">
          Moin Hasan Shaikh
        </a>
      </p>
    </div>
  );
};

export default moin_shaikh;
